/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_9_AInputs */

const en_mk_pricing_faq_9_a = /** @type {(inputs: Mk_Pricing_Faq_9_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, by arrangement. We have not published a package you can install yourself, so what we offer is an installation we carry out on your infrastructure, together with a maintenance agreement. Email m.farid.mahardika45@gmail.com with your team size and the environment you run, and we will come back with scope and cost.`)
};

const id_mk_pricing_faq_9_a = /** @type {(inputs: Mk_Pricing_Faq_9_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa, lewat pembicaraan langsung. Kami belum menerbitkan paket yang bisa Anda pasang sendiri, jadi yang kami tawarkan adalah pemasangan yang kami kerjakan di infrastruktur Anda beserta kesepakatan perawatannya. Kirim surel ke m.farid.mahardika45@gmail.com dengan gambaran ukuran tim dan lingkungan yang Anda pakai, dan kami balas dengan cakupan serta biayanya.`)
};

/**
* | output |
* | --- |
* | "Yes, by arrangement. We have not published a package you can install yourself, so what we offer is an installation we carry out on your infrastructure, toget..." |
*
* @param {Mk_Pricing_Faq_9_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_9_a = /** @type {((inputs?: Mk_Pricing_Faq_9_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_9_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_9_a(inputs)
	return en_mk_pricing_faq_9_a(inputs)
});